import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./Aboutus.css";
import image from "../assets/about.png";

const AboutUs = ({ scrollToContact }) => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleContactUs = () => {
    scrollToContact(); // Scroll to the contact section
  };

  const handleReadMore = () => {
    navigate("/aboutus-knowmore"); // Navigate to the "aboutus-knowmore" page
  };

  return (
    <div id="about" className="about-us-page">
      <header className="header">
        <h1>GET EXPERT FINANCIAL ADVICE...</h1>
        <p>BECAUSE EXPERT KNOWS THE BEST</p>
        <button onClick={handleContactUs} className="btn">
          Contact Us
        </button>
      </header>

      <section className="section">
        <img
          src={image}
          alt="Team working together"
          className="image"
        />
        <div className="content">
          <h1>WELCOME TO TAX O WEALTH</h1>

          <section className="intro">
            <p>
              <strong>
                A reputed name for comprehensive financial advisory and product
                distribution services.
              </strong>
            </p>
            <p>
              At Tax O Wealth, our mission is to provide our clients with the best
              solutions in wealth creation and wealth management. We are driven to
              provide clients with simple, unbiased, and uncluttered professional advice
              that adds value to their quality of life and results in actionable
              solutions.
            </p>
          </section>

          <section className="services">
            <h2>Our Approach</h2>
            <p>
              At Tax O Wealth, we offer our services through personal counsel with each
              of our clients after understanding their wealth management needs. Our
              approach is to enable our clients to understand their investments, have
              knowledge of investment products, and progress toward achieving their
              financial goals in life.
            </p>
          </section>

          <button onClick={handleReadMore} className="btn">
            Know More...
          </button>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
